export default "__VITE_ASSET__6b69b527__"